<script>
  import Select from "svelte-select";
  import Region from "../components/region.svelte";
  import { regions } from "../config/regions";
  import { step, user } from "../stores";

  let regionId;

  const onSubmit = ({ region }) => {
    user.update((u) => ({
      ...u,
      region,
    }));

    step.set(2);

    window.scrollTo(0, 0);
  };
</script>

<div class="section">
  <div class="container">
    <h3 style="margin-bottom: 32px">In quale regione risiedi?</h3>

    <!-- <h4 style="font-weight: 300">(in ordine alfabetico)</h4> -->

    <Select
      placeholder="Seleziona una regione..."
      items={regions.map((r) => ({
        value: r.id,
        label: r.nome,
      }))}
      on:select={(e) => {
        regionId = e.detail.value;
      }}
    />

    {#if regionId}
      <div class="cta">
        <button on:click={() => onSubmit({ region: regionId })}> AVANTI </button>
      </div>
    {/if}

    <!-- <div class="buttons">
      {#each regions as region}
        <button on:click={() => onSubmit({ region: region.id })}>
          <Region id={region.id} />

          <p>
            {region.nome}
          </p>
        </button>
      {/each}
    </div> -->
  </div>
</div>

<style>
  .section {
    padding-bottom: 32px;
  }

  :global(.selectContainer input) {
    font-size: 16px !important;
    top: 0;
  }

  .cta button {
    cursor: pointer;
    display: block;
    width: 100%;
    padding: 16px;
    margin-top: 16px;
    background-color: #2ecc71;
    color: white;
    font-weight: 700;
    text-shadow: 0 0 2px rgba(0, 0, 0, 0.25);
    text-transform: uppercase;
  }

  .buttons {
    display: flex;
    flex-wrap: wrap;
    margin-top: 32px;
  }

  .buttons button {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    flex-shrink: 0;
    flex-grow: 1;
    width: calc(25% - 8px);
    margin: 8px 4px 0;
    padding: 16px;
    background-color: #fff;
  }

  .buttons button p {
    margin: 16px 0 0;
    font-size: 16px;
    font-weight: 700;
    color: #777;
  }

  @media screen and (max-width: 768px) {
    .buttons button {
      width: calc(50% - 8px);
    }
  }
</style>
